import { render, staticRenderFns } from "./PeopleForm.vue?vue&type=template&id=b11ed7e2"
import script from "./PeopleForm.vue?vue&type=script&lang=js"
export * from "./PeopleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports